/**
 * Removes optional LOINC- at beginning of code.
 * Loinc codes in BioExamObservation and BioExamOrder are stored without the `LOINC-` prefix.
 * This util is useful to pass codes from classic Sêmeia classes to thoses classes.
 */
export default function trimLoincCode(code: string): string {
  if (code.startsWith("LOINC-")) {
    const actualCode = code.slice(6);
    return actualCode;
  }

  return code;
}
